enum Roles {
  admin = 1,
  park = 2,
  support = 3,
  operator = 4

}

export class UserModel {
  id: number
  language: string
  username: string
  password: string
  name: string
  regionId: number | null
  districtId: number | null
  role: number | null
  features = true;

  static create(data: { [key: string]: any }): UserModel {
    const model = new UserModel();
    Object.assign(model, data);
    return model;
  }


  static currentUser(): UserModel {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  static isSuperAdmin() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser.ROLES.indexOf(Roles.admin) != -1;
  }

  fullname() {
    return name;
  }
}

export class RoleModel {
  _id: number;
  name: string;

  public static create(data: { [key: string]: any }): RoleModel {

    const model = new RoleModel();

    model._id = Number(data['_id']);
    model.name = data['name'];

    return model;
  }
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/models/user.ts